export const defaultSkillSuggestions = [
  'Bootstrap',
  'CSS3',
  'Computer Literate',
  'Matlab',
  'Visual Design Skills',
  'Principles and Practices of Engineering',
  'Emotional Intelligence',
  'Editing Video',
  'TypeScript',
  'Cash Handling',
  'Sales',
  'Goal Oriented',
  'Account Management',
  'Fluent in English',
  'Team Work',
  'High Attention to Detail',
  'HTML/CSS/JavaScript',
  'Business Strategy',
  'Fast Typing Skills',
  'Ability to Work Independently',
  'Java Programming',
  'JavaScript Programming',
  'Interpersonal Communication',
  'Complex Problem Solving',
  'Graphic Design',
  'Agile Project Management',
  'Linux',
  'Docker',
  'Microsoft Office',
  'Public Speaking',
  'Critical thinking and problem solving',
  'Adaptability',
  'Customer Service Skills',
  'Analytical Skills',
  'Analytical Thinking Skills',
  'Data Analysis',
  'Interpersonal Communication Skills',
  'Excellent Customer Service Skills',
  'Ability to Learn Quickly',
  'Project Management Skills',
  'Critical Thinking Skills',
  'Teamwork',
  'Ability to Work in a Team',
  'Customer Service',
  'Communication',
  'Fast Learner',
  'Active Listening',
  'Ability to Multitask',
  'Teamwork Skills',
  'Marketing',
  'Good time management',
  'Organizational Skills',
  'Detail Oriented',
];
